// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popform {
  height: 327px;
  position: relative;
  justify-content: space-between;
  right: 30px;
  width: 500px;
  padding: 5px;
}

.serviceform {
  padding-bottom: 10px;
}

.forminput {
  width: 100%;
  padding-top: 10px;
}

.buttonscancel {
  display: flex;
  flex-direction: row;
  justify-content: right;
  gap: 10px;
}

.forminput > div {
  width: 100%;
  padding-bottom: 10px;
  padding-top: 10px;
}

.redstar {
  color: red;
}

.formTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.fullForm {
  height: 510px;
  padding-left: 20px;
  overflow-y: scroll;
}

.forminput input {
  width: 100%;
  padding: 8px 12px;
}`, "",{"version":3,"sources":["webpack://./components/CreateService/CreateService.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AACF;;AACA;EACE,oBAAA;AAEF;;AAAA;EACE,WAAA;EACA,iBAAA;AAGF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;AAIF;;AAFA;EACE,WAAA;EACA,oBAAA;EACA,iBAAA;AAKF;;AAHA;EACE,UAAA;AAMF;;AAHA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAMF;;AAHA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;AAMF;;AAHA;EACE,WAAA;EACA,iBAAA;AAMF","sourcesContent":[".popform {\n  height: 327px;\n  position: relative;\n  justify-content: space-between;\n  right: 30px;\n  width: 500px;\n  padding: 5px;\n}\n.serviceform {\n  padding-bottom: 10px;\n}\n.forminput {\n  width: 100%;\n  padding-top: 10px;\n}\n.buttonscancel {\n  display: flex;\n  flex-direction: row;\n  justify-content: right;\n  gap: 10px;\n}\n.forminput > div {\n  width: 100%;\n  padding-bottom: 10px;\n  padding-top: 10px;\n}\n.redstar {\n  color: red;\n}\n\n.formTitle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.fullForm {\n  height: 510px;\n  padding-left: 20px;\n  overflow-y: scroll;\n}\n\n.forminput input {\n  width: 100%;\n  padding: 8px 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
